<template>
  <div class="splitter-container">
    <div class="panel-header">
        <div class="panel-header-title">{{ title }}</div>
        <div class="panel-header-pins">
          <a href="#" style="transform: rotate(90deg);" v-if="swap" :title="'Swap'">
              <span class="k-icon k-i-arrows-swap"></span>
          </a>
          <a href="#" @click="openStudyCitationsList()" v-if="filterstudycitations" :title="title">
            <span class="k-icon k-i-filter"></span>
          </a>
          <a href="#" @click="openCitationStudiesList()" v-if="filterCitationStudies" :title="title">
            <span class="k-icon k-i-filter"></span>
          </a>
          <a href="#" @click="openCitationStudiesList()" v-if="filter" :title="filtertitle">
            <span class="k-icon k-i-filter"></span>
          </a>
          <a href="#" @click="openAiAssistant()" v-if="info" :title="infotitle">
            <span class="k-icon k-i-info"></span>
          </a>
          <a href="#" @click="openAiAssistant()" v-if="assistant" :title="assistanttitle">
            <span class="k-icon k-i-info"></span>
          </a>
          <a href="#" @click="toggleDetach()" v-if="detach" :title="detachtitle">
            <span class="k-icon k-i-hyperlink-open"></span>
          </a>
          <a href="#" @click="toggleDetach()" v-if="aggregate" :title="aggregatetitle">
            <span class="k-icon k-i-aggregate-fields"></span>
          </a>
          <a href="#" v-if="edit" :title="edititle">
            <span class="k-icon k-i-pencil"></span>
          </a>
          <a href="#" @click="openTags()" v-if="tag" :title="tagtitle">
              <span class="k-icon k-i-comment"></span>
          </a>
        </div>
    </div>
    <component class="component" :is="component" :style="calculateHeight()" :editable="editable"></component>
    <kendo-window :ref="'detachWindow'"
                  :width="'100%'"
                  :title="title"
                  :visible="false"
                  :modal="true"
                  :top="'0px'">
        <component class="component" :is="component" :style="calculateHeight()"></component>
    </kendo-window>
    <kendo-window :ref="'popupStudyCitations'"
                  :width="'80%'"
                  :title="title"
                  :visible="false"
                  :modal="true"
                  :top="'0px'">
        <component class="component" :is="popup" :style="calculateHeight()"></component>
    </kendo-window>
    <kendo-window :ref="'popupCitationStudies'"
                  :width="'80%'"
                  :title="title"
                  :visible="false"
                  :modal="true"
                  :top="'0px'">
        <component class="component" :is="popup" :style="calculateHeight()"></component>
    </kendo-window>
    <kendo-window :ref="'popupTags'"
                  :width="'50%'"
                  :title="'Tag creation'"
                  :visible="false"
                  :modal="true"
                  :top="'0px'">
        <kendo-hierarchicaldatasource
          :ref="'tagDataSourceRef'"
          :data="tagsData.data"
          :schema="tagsData.schema">
        </kendo-hierarchicaldatasource>
        <kendo-dropdowntree
          :data-source-ref="'tagDataSourceRef'"
          :data-text-field="'tag'"
          :data-value-field="'tag'"
          :checkboxes-check-children="true"
          :check-all="false"
          :tag-mode="'multiple'"
          style="width: calc(100% - 250px);">
        </kendo-dropdowntree>
        <kendo-button>Save Tags</kendo-button>
        <kendo-button>Cancel</kendo-button>
    </kendo-window>
    <kendo-window :ref="'popupAiAssistant'"
                  :top="100"
                  :left="900"
                  :width="600"
                  :height="900"
                  positionMode="fixed"
                  :title="assistanttitle"
                  :visible="false"
                  :modal="false">
                      Related Keywords
                      <div style="display:flex; flex-direction: row;">
                        <kendo-datasource
                          :ref="'keywordDataSource'"
                          :data="keywordDataSource.data">
                        </kendo-datasource>
                        <kendo-grid
                          :ref="'keywordGrid'"
                          :data-source-ref="'keywordDataSource'"
                          :editable="'inline'"
                          :selectable="selectable"
                          style="width: calc(100% - 0px);"
                          :columns="keywordColumns">
                        </kendo-grid>
                      </div>
                      Suggested Natural Language Question (NLQ)
                      <div style="display:flex; flex-direction: row;">
                        <input type="radio" name="nlqOptions">
                        <textarea :rows="4" style="min-width:100px; max-width:100%; min-height:30px; height:100%; width:100%;" disabled="'disabled">What is the Study Initiation?</textarea>
                      </div>
                      Edited Natural Language Question (NLQ)
                      <div style="display:flex; flex-direction: row;">
                        <input type="radio" name="nlqOptions">
                        <textarea :rows="4" style="min-width:100px; max-width:100%; min-height:30px; height:100%; width:100%;">What is the Study Initiation?</textarea>
                      </div>
                      <div style="display:flex; justify-content: flex-end;">
                        <kendo-button @click="askQuestionFunction()">Ask Question</kendo-button>
                      </div>
                      <div style="display:flex; flex-direction: row;">
                        <h1>Potential Answers:</h1>
                      </div>
                      <div v-if="askQuestion">
                        Match 1 - Citation
                        <div class="answer">
                          Long-Term Safety Evaluation of Ubrogepant for the AcuteTreatment of Migraine: Phase 3, Randomized, 52-WeekExtension Trial
                          <!-- <textarea :rows="4" style="min-width:100px; max-width:100%; min-height:30px; height:100%; width:100%;"></textarea> -->
                        </div>
                        <div style="height:20px;">&nbsp;</div>
                        Match 2 - Abstract
                        <div class="answer">
                          Objective: To evaluate the long-term safety and tolerability of ubrogepant for the acute treatment of migraine. Background(s): Ubrogepant is an oral, calcitonin gene-related receptor antagonist in development for the acute treatment of migraine. The efficacy of ubrogepant was demonstrated in 2 phase 3 trials in which a significant improvement was observed in migraine headache pain, migraine-associated symptoms, and ability to function.
                          <!-- <textarea :rows="4" style="min-width:100px; max-width:100%; min-height:30px; height:100%; width:100%;"></textarea> -->
                        </div>
                        <div style="height:20px;">&nbsp;</div>
                        Match 3 - File name: S01_COH_2025_TALQUETAMA(45332).pdf
                        <div class="answer">
                          Long-Term Safety Evaluation of Ubrogepant for the AcuteTreatment of Migraine: Phase 3, Randomized, 52-WeekExtension Trial
                          <!-- <textarea :rows="4" style="min-width:100px; max-width:100%; min-height:30px; height:100%; width:100%;"></textarea> -->
                        </div>
                      </div>
        <component class="component" :is="popup" :style="calculateHeight()"></component>
        <PopUpAIAssistant></PopUpAIAssistant>
    </kendo-window>
  </div>
</template>

<script>
import Filters from '@/views/secure/cards/Filters'
import FiltersBatchReview from '@/views/secure/cards/FiltersBatchReview'
import CitationList from '@/views/secure/cards/CitationList'
import CitationListDiscrepancies from '@/views/secure/cards/CitationListDiscrepancies'
import CitationListDataDiscrepancies from '@/views/secure/cards/CitationListDataDiscrepancies'
import CitationListValidation from '@/views/secure/cards/CitationListValidation'
import CitationListBatchReview from '@/views/secure/cards/CitationListBatchReview'
import Annotations from '@/views/secure/cards/Annotations'
import AnnotationsBatchReview from '@/views/secure/cards/AnnotationsBatchReview'
import Abstract from '@/views/secure/cards/Abstract'
import AbstractBatchReview from '@/views/secure/cards/AbstractBatchReview'
import Citation from '@/views/secure/cards/Citation'
import CitationBatchReview from '@/views/secure/cards/CitationBatchReview'
import ActionsManageStagesForms from '@/views/secure/cards/ActionsManageStagesForms'
import ActionsNavigateCitations from '@/views/secure/cards/ActionsNavigateCitations'
import ActionsNavigateCitationStudies from '@/views/secure/cards/ActionsNavigateCitationStudies'
import ActionsNavigateStudies from '@/views/secure/cards/ActionsNavigateStudies'
import ActionsDE from '@/views/secure/cards/ActionsDE'
import ActionsBatch from '@/views/secure/cards/ActionsBatch'
import ActionsStageDiscrepancies from '@/views/secure/cards/ActionsStageDiscrepancies'
import ActionsDataDiscrepancies from '@/views/secure/cards/ActionsDataDiscrepancies'
import ActionsValidation from '@/views/secure/cards/ActionsValidation'
import ActionsBatchReview from '@/views/secure/cards/ActionsBatchReview'
import Forms from '@/views/secure/cards/Forms'
import FormsDataDiscrepancies from '@/views/secure/cards/FormsDataDiscrepancies'
import FullText from '@/views/secure/cards/FullText'
import FullTextBatchReview from '@/views/secure/cards/FullTextBatchReview'
import PopUpCitationStudies from '@/views/secure/cards/PopUpCitationStudies'
import PopUpStudyCitations from '@/views/secure/cards/PopUpStudyCitations'
import PopUpAiAssistant from '@/views/secure/cards/PopUpAiAssistant'
import TagsData from '@/assets/data/Tags.json'
import KeywordDataSource from '@/assets/data/Keyword2.json'

export default {
  name: 'SplitterContainer',
  props: ['title', 'detach', 'detachtitle', 'aggregate', 'aggregatetitle', 'edit', 'edittitle', 'swap', 'swaptitle', 'filter', 'filtertitle', 'tag', 'tagtitle', 'filterstudycitations', 'filtercitationstudies', 'info', 'infotitle', 'assistant', 'assistanttitle', 'component', 'popup', 'editable'],
  components: {
    Filters,
    FiltersBatchReview,
    CitationList,
    CitationListDiscrepancies,
    CitationListDataDiscrepancies,
    CitationListValidation,
    CitationListBatchReview,
    Annotations,
    AnnotationsBatchReview,
    Abstract,
    AbstractBatchReview,
    Citation,
    CitationBatchReview,
    ActionsManageStagesForms,
    ActionsNavigateCitations,
    ActionsNavigateStudies,
    ActionsNavigateCitationStudies,
    ActionsDE,
    ActionsBatch,
    ActionsDataDiscrepancies,
    ActionsStageDiscrepancies,
    ActionsValidation,
    ActionsBatchReview,
    Forms,
    FormsDataDiscrepancies,
    FullText,
    FullTextBatchReview,
    PopUpCitationStudies,
    PopUpStudyCitations,
    PopUpAiAssistant
  },
  data () {
    return {
      askQuestion: false,
      tagsDataSource: [
        { value: '1', text: 'Tag 1' },
        { value: '2', text: 'Tag 2' },
        { value: '3', text: 'Tag 3' },
        { value: '4', text: 'Tag 4' }
      ],
      tagsData: TagsData,
      keywordDataSource: KeywordDataSource,
      keywordColumns: [
        {
          title: '',
          headerAttributes: { class: 'grid-header-light' },
          columns: [
            { field: 'KeywordName', title: 'Keyword Name', headerAttributes: { class: 'grid-header-light' }, width: '120px' },
            { field: 'Type', title: 'Group', headerAttributes: { class: 'grid-header-light' } },
            { field: 'Aliases', title: 'Aliases', headerAttributes: { class: 'grid-header-light' }, width: '50px' },
            { field: 'Include', title: 'Include', headerAttributes: { class: 'grid-header-light' }, template: '<input type="checkbox" #if (Include) { # checked # } #>' },
            { field: 'Exclude', title: 'Exclude', headerAttributes: { class: 'grid-header-light' }, template: '<input type="checkbox" #if (Exclude) { # checked # } #>' },
            { field: 'Data', title: 'Data', headerAttributes: { class: 'grid-header-light' }, template: '<input type="checkbox" #if (Data) { # checked # } #>' },
            { field: 'Color', title: 'Color/Meaning', headerAttributes: { class: 'grid-header-light' }, template: '<div style="color: #:Color #;">#:Color #</div>' }
          ]
        }
      ]
    }
  },
  methods: {
    askQuestionFunction: function () {
      this.askQuestion = true
    },
    calculateHeight: function () {
      if (this.component === 'citation-list' | this.component === 'citation-list-discrepancies') {
        return 'height: calc(100% - 90px)'
      } else {
        return 'height: calc(100% - 30px)'
      }
    },
    toggleDetach: function () {
      var windowWidget = this.$refs.detachWindow.kendoWidget()
      windowWidget.open()
      windowWidget.maximize()
    },
    openStudyCitationsList: function () {
      var windowWidget = this.$refs.popupStudyCitations.kendoWidget()
      windowWidget.open()
    },
    openCitationStudiesList: function () {
      var windowWidget = this.$refs.popupCitationStudies.kendoWidget()
      windowWidget.open()
    },
    openAiAssistant: function () {
      // var windowWidget = this.$refs.popupAiAssistant.kendoWidget()
      // console.log('windowWidget')
      // console.log(windowWidget)
      // console.log(windowWidget.options.position)
      // windowWidget.options.position = { top: 90, left: 90 }
      // windowWidget.open().position = { top: 0, left: 0 }
      this.$store.state.showAiAssistant = true
    },
    openTags: function () {
      var windowWidget = this.$refs.popupTags.kendoWidget()
      windowWidget.open()
    }
  }
}
</script>

<style scoped>
  .k-icon::before {
    color: #263246 !important;
  }

  .k-icon.k-i-close {
    color: #263246 !important;
  }

  .span.k-icon.k-i-close::before {
    color: #263246 !important;
  }

  .answer {
    display:flex;
    flex-direction: row;
    background-color: #1b84db;
    color: rgb(255, 255, 255);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    padding: 10px;
  }
</style>
